import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { Badge, OutlineCard } from '@morressier/alembic';
import RichTextPreview from '../../GenericFieldComponents/RichText/RichTextPreview';
import { IPublicationHistoryItemType } from '@publishing-engine/domain/types/AuthorType';
import { AuthorSubmissionTransferHistory } from '../AuthorSubmissionTransferHistory';
import TextWithIcon from 'src/components/TextWithIcon';
import { faFileLines, faBooks } from '@fortawesome/pro-regular-svg-icons';
import { SubmissionTags } from 'src/pages/Organization/Workspace/Submissions/SubmissionTags';
import { SubmissionAuthors } from 'src/pages/Organization/Workspace/Submissions/SubmissionAuthors';
import { SubmissionPhase } from 'src/pages/Organization/Workspace/Submissions';
import dateFormat from 'dateformat';

type IPublicationHistoryItemProps = {
  data: IPublicationHistoryItemType;
};

const PublicationHistoryItemCard = ({ data }: IPublicationHistoryItemProps) => {
  const { id, manuscriptId, submission, workflow, journal, tags } = data;

  return (
    <OutlineCard key={id}>
      <Flex
        gap={2}
        borderBottomWidth="1px"
        borderBottomColor="neutralPrimaryBorder"
        padding={4}
        textStyle={'textContext'}
        flexWrap="wrap"
      >
        <Badge size="context" variant="attention">
          # {manuscriptId}
        </Badge>
        <SubmissionPhase currentState={workflow.currentState} />
        <Text marginStart={'auto'}>
          Submitted on {''}
          {data.workflow.submissionCreated
            ? dateFormat(
                data.workflow.submissionCreated! , 'mmmm d, yyyy'
              )
            : null}
        </Text>
      </Flex>
      <Flex flexDirection={'column'} padding={4} gap={2}>
        <Flex gap={2} flexWrap="wrap">
          <TextWithIcon icon={faFileLines} text={submission.documentType} />
          <TextWithIcon
            icon={faBooks}
            text={journal?.name || 'No data available'}
          />
        </Flex>
        <Flex flexDirection={'column'}>
          <Tooltip
            hasArrow
            borderRadius={4}
            placement="top"
            label={<RichTextPreview value={submission?.title} />}
          >
            <Box>
              <RichTextPreview
                value={submission?.title}
                textStyle="headingGroup"
                noOfLines={1}
              />
            </Box>
          </Tooltip>
          <SubmissionAuthors
            submittingAuthor={submission.submitter}
            authors={submission.authors}
            maxWidth="100%"
          />
        </Flex>
        {!!(tags?.length || submission?.transferHistory?.length) && (
          <Flex justifyContent={'space-between'} alignItems={{ base: 'flex-start', md: 'flex-end' }} flexDirection={{ base: 'column', md: 'row' }} gap={2}>
            <Box marginTop={-1}>
              <SubmissionTags id={id} tags={tags} maxWidth={'100%'} />
            </Box>
            <AuthorSubmissionTransferHistory
              items={submission?.transferHistory?.reverse()}
            />
          </Flex>
        )}
      </Flex>
    </OutlineCard>
  );
};

export default PublicationHistoryItemCard;
